export default {
  state: {
    empresa: '',
    menu: null,
    menuReportes: null,
    usuario: ''
  }
}
